const INTERVAL = 5;

function Timer (cb) {
    if (!cb) console.error('No Timer Callback Provided');
    this.timerCallback = cb;
    this.timeLeft = INTERVAL;
}

Timer.prototype.restart = function () {
    // console.log('Timer.restart');
    this.timeLeft = INTERVAL;
    this.tick();
};

Timer.prototype.stop = function () {
    clearInterval(this);
}

Timer.prototype.decrementTimeleft = function () {
    // console.log('decrementTimeleft', this.timeLeft);
    this.timeLeft -= 1;
    this.tick();
};

Timer.prototype.tick = function () {
    setTimeout(function () {
        // console.log('tick', this.timeLeft);
        if (this.timeLeft == 1) {
            this.timerCallback();
        } else {
            this.decrementTimeleft();
        }
    }.bind(this),
    Math.min(1, this.timeLeft) * 1000
    );
};

export default Timer;
